
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class MemberForm extends Vue {
  @Prop({ required: true }) private roles!: number[];

  @Prop({ required: true }) private userId!: string;

  @Prop({ required: true }) private userIdPublic!: string;

  @Prop({ required: true }) private createdOn!: string;

  @Prop({ required: true }) private inviter!: string | null;

  @Prop({ required: true }) private inviterPId!: string | null;

  @Prop({ required: true }) private registerPlatform!: number | null;

  @Prop({ required: true }) private authStatus!: number;

  @Prop({ required: true }) private dataAudiFlow!: number;

  @Prop({ required: true }) private authFailReason!: string | null;

  @Prop({ required: true }) private profilePic!: string;

  private get basic() {
    return this.authStatus ? '通過' : '尚未';
  }
}
